import classNames from 'classnames';
import { debounce } from 'lodash-es';
import React, { FC, useCallback, useState } from 'react';
import { useMount, useUnmount } from 'react-use';

import { Breakpoint, DEFAULT_BREAKPOINTS } from './Breakpoints';
import {
  ResponsiveContext,
  ResponsiveContextProps,
  responsiveDefaults,
} from './ResponsiveContext';

interface ResponsiveProps {
  breakpoints?: Breakpoint[];
}

export const Responsive: FC<React.PropsWithChildren<ResponsiveProps>> = ({
  breakpoints = DEFAULT_BREAKPOINTS,
  children,
}) => {
  const [matches, setMatches] = useState<ResponsiveContextProps>({
    ...responsiveDefaults,
  });

  const checkMatches = useCallback(() => {
    const matches: any = {};

    for (const breakpoint of breakpoints) {
      matches[breakpoint.alias] = window.matchMedia(
        breakpoint.mediaQuery
      ).matches;
    }

    setMatches(matches);
  }, [breakpoints]);

  const onResize = debounce(() => {
    checkMatches();
  }, 10);

  useMount(() => {
    checkMatches();
    window.addEventListener('resize', onResize);
  });

  useUnmount(() => {
    window.removeEventListener('resize', onResize);
  });

  const keys = Object.keys(matches).filter((k) => matches[k]);

  return (
    <ResponsiveContext.Provider value={matches}>
      <div className={classNames(keys)}>{children}</div>
    </ResponsiveContext.Provider>
  );
};
